import React, { Component } from 'react'
import sendIcon from '../../../../../include/images/send-icon.svg'
import loaderIcon from '../../../../../include/images/loading-icon2.svg'
import { io } from 'socket.io-client'
import { getPatient, loadPatientProfile } from '../../../../../store/patient'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
  chatReceived,
  chatReceivedAll,
  getChats,
  loadChatForPatient,
} from '../../../../../store/chats'
import msgIcon from '../../../../../include/images/tab-message.svg'
import moment from 'moment'
import { collection, addDoc, serverTimestamp, query, where, orderBy, getDocs, updateDoc, doc, getDoc, } from "firebase/firestore";
import { db } from '../../../../../firebase'
import { sendMessage } from '../../../../../chatUtils/chatUtiles'
class Messeges extends Component {
  myRef = React.createRef()
  scrollToMyRef = (appointmentDate = "") => {
    if (this.myRef.current) {
      let element = document.getElementById(appointmentDate);

      if (appointmentDate && element && this.props.initial) {
        this.myRef.current.scrollTo(0, element.offsetTop -(document.getElementsByClassName('sidebar-head')[0].offsetHeight + 90))
      } else {
        const chatBox = this.myRef.current;
        const isUserNearBottom =
          chatBox.scrollTop + chatBox.clientHeight >= chatBox.scrollHeight - 100;

        if (isUserNearBottom) {
          chatBox.scrollTo({
            top: chatBox.scrollHeight,
            behavior: "smooth",
          });
        }
      }
    }
  };
  scrollToBottom = () => {
    if (this.myRef.current) {
      this.myRef.current.scrollTo({
        top: this.myRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  state = {
    ready: false,
    msgData: '',
    initialBottomScrollDone: false,
    loading: true,
  }
  loadMessages = async () => {
    if (!this.props.doctor_id || !this.props.patient_id) return;
    const q = query(
      collection(db, "messages"),
      where("sender", "in", [this.props.patient_id, this.props.doctor_id]),
      where("receiver", "in", [this.props.patient_id, this.props.doctor_id]),
      orderBy("created_on", "asc")
    );
    const snapshot = await getDocs(q);
    const msgs = snapshot.docs.map((doc) => {
      const data = doc.data();
      // console.log("msg data------------------> ",data)
      return {
        ...data,
        created_on: data.created_on?.toDate?.().toISOString() || data.created_on,
        time: data.time?.toDate?.().toISOString() || data.time,
      };
    });
    // console.log("messages ------------999----------> ", msgs)
    this.props.chatReceivedAll(msgs);

    const chatId = `${this.props.doctor_id}_${this.props.patient_id}`;
    const chatDocRef = doc(db, "chatsSummary", chatId);
    const chatDocSnap = await getDoc(chatDocRef);
    if(chatDocSnap.exists() && (this.props.tab === "messages" || this.props.tab === "message")){
      const data = chatDocSnap.data();
      if (data.readByPatient === false) {
        console.log("I am doing *******")
        await updateDoc(doc(db, "chatsSummary", chatId), {
          readByPatient: true,
        }, { merge: true });
      }
    }  
    // this.scrollToMyRef(false);
  };  
  handleSend = async (msg) => {
    if (msg) {
      await sendMessage({
        msg: this.state.msgData,
        doctorId: this.props.doctor_id,
        patientId: this.props.patient_id,
        sender: this.props.patient_id,
      })
      this.setState({ msgData: '' }, () => {
        this.scrollToBottom();
      });
      this.loadMessages();
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.pollInterval);
  }

  componentDidUpdate = (prevProps, prevState) => {
    // console.log("prevProps.chats.length----------> ", this.props.appointmentDate)
    if (this.props.doctor_id !== prevProps.doctor_id) {
      this.props.loadChatForPatient(this.props.doctor_id)
        this.setState({ loading: true }, () => {
          this.loadMessages().then(() => {
            this.setState({ loading: false });
          });
        })
    }
    if (this.props.tab === 'messages' && this.props.tab !== prevProps.tab) {
      this.props.loadChatForPatient(this.props.doctor_id)
        this.setState({ loading: true }, () => {
          this.loadMessages().then(() => {
            this.setState({ loading: false });
          });
        })
    }
    if (this.props.tab !== prevProps.tab && this.state.initialBottomScrollDone) {
      this.setState({ initialBottomScrollDone: false });
    }
    if (
      !this.props.appointmentDate &&
      !this.state.initialBottomScrollDone &&
      this.props.chats.length > 0 &&
      (this.props.tab === 'messages' || this.props.tab === 'message') &&
      prevProps.chats.length !== this.props.chats.length 
    ) {
      console.log("Scrolling to bottom...");
      this.scrollToBottom();
      this.setState({ initialBottomScrollDone: true });
    }
    if (prevState.loading && !this.state.loading) {
      this.scrollToBottom();
    }
  }  

  componentDidMount = () => {
    this.props.loadChatForPatient(this.props.doctor_id)
    // console.log("load message is started ------------------> ")
    this.loadMessages().then(() => {
      this.setState({ loading: false }); 
    });
    this.pollInterval = setInterval(() => {
      this.loadMessages();
    }, 5000);
  }
  render() {
    // console.log("this.props.lastAppointment.appointment_time : ", this.props.lastAppointment.appointment_time)
    const days = moment().diff(
      moment(this.props.lastAppointment.appointment_time),
      'days'
    )
    // this.scrollToMyRef()

    return (
      <>
        <div
          onClick={e => this.props.setTab('messages', e)}
          className={
            this.props.tab === 'messages' ? 'card-header active' : 'card-header'
          }>
          <i className="fa-solid fa-message-dots fa-lg" style={{ color: "#673ab7" }}></i>
          <b>Messages</b>
          {this.props.showUnreadDot && (
            <span style={{
              position: 'absolute',
              top: 22,
              right: 50,
              height: '10px',
              width: '10px',
              backgroundColor: '#8BB044',
              borderRadius: '50%',
              display: 'inline-block'
            }}></span>
          )}
        </div>
        <div
          className={
            this.props.tab === 'messages' ? 'content-body show' : 'content-body'
          }>
          <div className='chat-area'>
            <div className='chat' ref={this.myRef}>
              {this.state.loading ? (
                <div>
                  <b className='d-flex justify-content-center align-items-center pt-4 text-center'>
                    <img
                      src={loaderIcon}
                      alt='loader'
                      className='loader-img fa-spin'
                      style={{ height: '15px;' }}
                    />
                  </b>
                </div>
                ) : (
                this.props.chats.map((es, i) => {
                 const createdOn = es.created_on?.toDate?.() || es.created_on;
                 const time = es.time?.toDate?.() || es.time; 
                 return ( 
                <>
                  {(i === 0 ||
                    moment(
                      this.props.chats[i - 1]?.created_on?.toDate?.() ||
                        this.props.chats[i - 1]?.created_on
                    ).format("DD/MM/YYYY") !==
                      moment(createdOn).format("DD/MM/YYYY")) && (
                    <div
                      class="chat-seprator"
                      id={moment(createdOn).format("DD/MM/YYYY")}
                    >
                    <span>{moment(createdOn).format("DD/MM/YYYY")}</span>
                    <div className="alert_box">
                      <div className="alert_box_content">
                      This chat is not for emergency purposes. Messages exchanged here is between you and your respective field expert only. YesMindy has no role in checking the messages or responses by the expert. Reply from the expert may take sometime. 
                      </div>
                      </div>              
                    </div>
                  )}
                  {this.props.patient_id === es.sender ? (
                    <div class='chat-message-box send-message'>
                      <div>
                        <div class='chat-message'>{es.msg || es.message}</div>
                      </div>
                      <div class='time'>
                        {moment(createdOn).format('hh:mm:ss A')}{' '}
                      </div>
                    </div>
                  ) : (
                    <div class='chat-message-box received-message d-flex flex-column align-items-end'>
                      <div class='d-flex flex-column'>
                        <div class='chat-message'>{es.msg || es.message}</div>
                      </div>
                      <div class='time'>
                        {' '}
                        {moment(time || createdOn).format('hh:mm:ss A')}{' '}
                      </div>
                    </div>
                  )}
                </>
                 );
              }))}
            </div>
            {/* {console.log("days------------------> ",days)} */}
            {this.props.lastAppointment.appointment_time && days < 3 && (
              <>
                <div className='send'>
                  <input
                    onChange={e => this.setState({ msgData: e.target.value })}
                    className='input-message'
                    name='msgData'
                    value={this.state.msgData}
                    placeholder='Write your message…'
                    type='text'
                    id='message'
                    onKeyDown={e => {
                      if (e.key === 'Enter') this.handleSend(this.state.msgData)
                    }}
                  />
                  <button
                    className='input-send'
                    onClick={e => {
                      if (this.state.msgData) this.handleSend(this.state.msgData)
                    }}>
                    <i>
                      <img src={sendIcon} alt='' />
                    </i>
                  </button>
                </div>             
                <div style={{ textAlign: 'center', marginTop: '6px', fontSize: '12px', fontStyle: 'italic' }}>
                  You are chatting with{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {
                      this.props.doctor_id === this.props.psychiatrist?._id
                        ? this.props.psychiatrist?.name
                        : this.props.psychologist?.name
                    }
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  patientProfile: getPatient(state).profile,
  patientHistory: getPatient(state).history,
  psychiatrist: getPatient(state).psychiatrist,
  psychologist: getPatient(state).psychologist,
  loading: getPatient(state).loading,
  chats: getChats(state).chatData,
  lastAppointment: getChats(state).lastAppointment,
})
const mapDispatchToProps = dispatch => ({
  loadPatientProfile: () => dispatch(loadPatientProfile()),
  chatReceived: data => dispatch(chatReceived(data)),
  chatReceivedAll: (data) => dispatch(chatReceivedAll(data)),
  loadChatForPatient: id => dispatch(loadChatForPatient(id)),
})
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Messeges)
)
